import React from 'react';

import { history } from 'src/history';
import { routes } from 'src/routes';
import { FloatingButton } from 'src/ui/atoms/floating-button';

export const CreateGroupButton = () => {
	return (
		<FloatingButton
			onClick={() => history.push(routes.root.home.createGroup.path)}
		>
        <span style={{ fontSize: 40, fontWeight: 100}} >+</span>
		</FloatingButton>
	);
};
